import React from "react";

const HighLowPrice = ({ highPrice, lowPrice }) => {
  return (
    <div className="d-block">
      <span className="text_up">High: {highPrice}</span>
      <span className="text_down">Low: {lowPrice}</span>
    </div>
  );
};

export default HighLowPrice;
